import {ERequestType, TRequestTableResponseWithPagination} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {AIS3_COMMENTS_REQUEST_API_PREFIX} from './ais-comments-request-constants';
import {IAisCommentsRequestResultTableDto, IAisInspectorCommentDto} from './ais-comments-request-types';

export const fetchAisCommentsRequestTable = (
    params?: IFetchAisCommentsRequestTableParams,
) => performRequest<TRequestTableResponseWithPagination<IAisCommentsRequestResultTableDto>>({
    url: AIS3_COMMENTS_REQUEST_API_PREFIX,
    method: ERequestType.GET,
    params,
});

export const fetchAisCommentsRequestRowsTable = (
    {
        requestId,
    }: IFetchAisCommentsRequestRowsTableParams,
) => performRequest<IAisInspectorCommentDto>({
    url: `${AIS3_COMMENTS_REQUEST_API_PREFIX}/${requestId}`,
    method: ERequestType.GET,
});

export const postAisCommentsRequest = async (
    data: IPostAisCommentsRequestData,
) => performRequest<string>({
    url: `${AIS3_COMMENTS_REQUEST_API_PREFIX}/saveCommentsRequest`,
    method: ERequestType.POST,
    data,
});

export interface IFetchAisCommentsRequestTableParams {
  length?: number;
  paginationCurrent?: number;
  paginationPageSize?: number;
  search?: string | null;
  sorterField?: string;
  sorterOrder?: 'ascend' | 'descend';
  start?: number;
}

export interface IPostAisCommentsRequestData {
  id: number;
  comment?: string;
}

export interface IFetchAisCommentsRequestRowsTableParams {
  requestId: number;
}
